<template>
  <div>

  </div>
</template>

<script>
  import '../browserMusic/qqmusic_h5'
  import { setTimeout } from 'timers';
  export default {
    name: '',
    data() {
      return {
        state: '',
        player: ''
      }
    },
    methods: {
      setBar() {
        M.client.open('ui', 'setStatusBar', { hide: '0', colorType: '1' }, (res) => {
          console.log(res)
        })
      },
      initClienPlayer() {
        M.musicReady(() => {
          M.client.on('playStateChange', function (res) {
            const { data } = res;
            this.$emit('updataCurrId', data.songid)
            if (data.state === 'playing') {
              this.$emit('updataState', 'playing')
            } else if (data.state === 'pause') {
              this.$emit('updataState', 'pause')
            }
          })
        })
      }
    },
    mounted() {
      this.setBar()
      setTimeout(() => {
        this.initClienPlayer()
      }, 300)
    },
    created() {
      this.$emit('initPlayer', new window.Player())
    }
  }
</script>